'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { filterChipLabelStyles } from './styles/filter-chip-label.styles';
import type { FilterChipLabelPropsInterface } from './types/filter-chip-label.types';

/**
 * @since 10.0.0
 */
export const FilterChipLabel = forwardRef<HTMLSpanElement, FilterChipLabelPropsInterface>(
  (props, forwardedRef) => {
    const { children, className, css: cssProp, truncate = true, ...rest } = props;

    const styles = css({ truncate }, filterChipLabelStyles, cssProp);

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="FilterChip.Label"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </span>
    );
  },
);

FilterChipLabel.displayName = 'FilterChip.Label';
